var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 171,
    viewBox: "0 0 251 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M77.461 89.2509C77.461 89.2509 77.2527 84.025 79.8657 80.6832C82.4786 77.3413 84.8288 74.8524 85.8849 74.3863C86.941 73.9202 88.4632 73.6227 89.2267 72.4526C89.9903 71.2825 91.4529 69.2893 92.9206 69.1108C94.3832 68.9372 97.7845 68.3472 97.7845 68.3472L100.244 65.8285V64.4798C100.244 64.4798 98.7216 64.5988 98.1366 64.1278C97.5515 63.6568 95.7319 59.0308 96.2029 57.6822C96.6739 56.3336 98.5481 55.5155 98.5481 55.5155C98.5481 55.5155 101.711 45.9065 105.99 44.0918C110.269 42.2771 123.979 45.733 123.979 45.733C123.979 45.733 124.975 55.927 125.035 55.7535C125.094 55.5799 128.257 54.8759 128.257 54.8759C128.257 54.8759 128.257 60.4439 127.028 61.2025C125.798 61.9661 125.154 62.0801 125.154 62.0801C125.154 62.0801 125.679 65.1294 124.921 67.7622C124.157 70.3999 122.342 73.0922 122.342 73.0922C122.342 73.0922 131.951 76.548 133.885 78.4222C135.819 80.2964 142.557 89.2013 144.724 93.7727C146.89 98.3442 147.535 100.392 148.883 101.448C150.232 102.504 152.166 103.793 152.751 104.378C153.336 104.963 154.159 106.252 155.037 108.305C155.914 110.358 160.312 115.628 160.312 115.628L138.808 117.443C138.808 117.443 133.359 113.635 131.897 112.054C130.434 110.472 129.844 109.416 129.844 109.416L126.681 117.443C126.681 117.443 152.404 116.972 155.979 116.565C159.553 116.154 165.414 115.157 167.992 114.751C170.571 114.339 183.343 111.587 184.984 112.113C186.625 112.639 190.552 114.518 191.663 115.861C192.778 117.21 194.474 121.37 193.596 123.537C192.719 125.703 188.911 127.523 188.207 127.697C187.503 127.87 184.572 128.753 183.873 128.926C183.169 129.1 181.766 129.571 180.77 129.045C179.773 128.52 178.484 127.637 178.484 127.637C178.484 127.637 176.317 127.052 174.676 126.581C173.035 126.11 166.882 125.703 165.771 125.644C164.66 125.584 159.558 126.992 159.558 126.992C159.558 126.992 160.674 128.986 160.377 129.804C160.079 130.622 156.921 134.489 156.921 134.489L153.405 134.137L152.29 135.6L148.715 134.603L147.252 135.421L144.793 135.069C144.793 135.069 120.538 130.265 116.611 126.631C112.684 122.996 84.6751 104.775 84.6751 104.775L77.461 89.2509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M128.679 138.555L85.5234 151.51L95.3753 156.895L132.963 162.736L171.558 147.226L171.468 145.491C171.468 145.491 128.769 139.105 128.679 138.555Z",
    fill: "white",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M131.043 156.479L161.968 145.799L130.22 140.831L99.5938 151.064L131.043 156.479Z",
    fill: "#272637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.2035 60.8403C80.9704 58.1084 81.6894 55.3962 83.2958 53.175C85.5121 50.1108 88.1003 45.4749 87.7235 40.9283C87.4309 37.3981 84.337 32.3259 85.0708 29.4204C85.8046 26.5149 88.6407 20.3717 84.1238 16.0631C80.3556 12.4684 77.6485 12.7857 73.672 10.7578C70.2856 9.03236 64.4895 5.20961 57.4984 8.14485C51.3057 10.7479 50.9983 15.5573 47.4631 17.8083C43.9329 20.0544 39.9267 21.7154 38.5185 29.8864C37.0807 38.236 41.3794 41.6571 36.7981 45.9856C32.2167 50.3141 20.7832 45.6138 18.3636 59.5809C16.5142 70.2559 23.9167 72.2937 26.4603 74.5298C29.0038 76.766 64.7275 82.6067 70.8756 78.8881C80.4845 73.0771 81.6001 65.4613 81.2035 60.8403Z",
    fill: "#272637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M53.4952 43.3723L44.625 58.0137L57.2287 84.2673L70.1943 55.7479L53.4952 43.3723Z",
    fill: "white",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M83.7134 30.5255C83.7134 30.5255 82.2904 47.4577 76.1423 54.9296C70.7131 61.524 66.1367 60.8348 61.2826 55.5792C57.3012 51.2705 53.1958 44.3539 53.1958 44.3539C53.1958 44.3539 48.4459 42.0979 49.9631 38.3198C51.4753 34.5416 55.3972 37.3281 55.3972 37.3281C55.3972 37.3281 59.5324 37.8537 59.5819 31.061C59.6216 26.0582 63.96 19.3547 74.2482 21.2488C84.5364 23.1477 83.7134 30.5255 83.7134 30.5255Z",
    fill: "white",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M76.3896 48.8861C76.3896 48.8861 74.3716 48.9604 72.2247 47.9688C70.0778 46.9772 68.5011 45.8021 68.5011 45.8021C68.5011 45.8021 67.5888 49.8281 70.3307 51.3899C73.7171 53.3187 76.3896 48.8861 76.3896 48.8861Z",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.8108 34.0814C76.8356 34.25 76.0473 38.4049 77.2174 41.8508C77.4852 42.6441 77.1331 43.6804 75.9283 43.7548C74.2177 43.8589 73.5781 42.8821 73.5781 42.8821",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M66.3748 71.7932L59.8944 88.6361C59.8944 88.6361 49.8194 79.0768 44.8117 70.8313C39.8039 62.5908 33.0707 58.416 33.0707 58.416C33.0707 58.416 18.34 65.9079 11.8745 77.5447C5.40904 89.1815 5.52804 101.517 3.02912 113.387C1.28384 121.687 0.71365 135.372 0.480616 140.211C0.118669 147.733 0.847522 155.869 1.26401 159.31C1.63587 162.394 3.78772 166.103 5.64207 167.545C7.50139 168.988 19.4208 171.195 20.9678 170.986C22.5147 170.778 30.4379 165.151 30.7701 162.543C31.608 155.963 21.4934 150.95 25.5194 149.404C29.5454 147.857 33.155 147.673 33.155 147.673C33.155 147.673 52.0456 151.069 60.1126 148.967C68.1795 146.865 61.2282 144.545 61.2282 144.545L74.0203 117.567C74.0203 117.567 87.7891 128.768 88.8402 130.518C89.8914 132.268 91.6416 135.654 92.8068 135.888C93.972 136.121 95.1421 137.871 97.1254 138.57C99.1086 139.269 100.626 137.053 100.626 137.053C100.626 137.053 99.4606 127.949 103.893 124.216C108.326 120.482 116.289 121.658 116.289 121.658C116.289 121.658 116.289 119.645 114.826 118.732C113.363 117.815 106.407 116.233 105.619 116.109C104.825 115.985 104.701 115.257 103.789 114.22C102.872 113.184 100.071 111.657 98.4244 110.745C96.7783 109.832 96.5353 110.318 95.9255 109.827C95.3156 109.341 93.6695 105.618 90.9871 102.935C88.3048 100.253 84.5812 95.1264 81.3484 89.5187C78.1157 83.906 76.653 82.5673 75.4333 81.2832C74.2136 80.004 69.8851 74.5747 68.601 73.355C67.3168 72.1353 66.3748 71.7932 66.3748 71.7932Z",
    fill: "#C1C1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.4787 145.02C34.4787 145.02 30.1205 139.447 20.3628 139.214C14.5518 139.075 8.76562 141.683 8.76562 141.683",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M101.75 150.212C101.75 150.212 110.511 156.196 112.921 156.052C115.331 155.908 115.916 154.882 115.916 154.079C115.916 153.276 105.697 144.956 104.675 144.445C103.654 143.934 90.4405 140.285 89.0522 140.285C87.6639 140.285 66.4975 141.088 63.0665 141.455C59.6354 141.822 35.7667 145.105 34.4528 145.105C33.1389 145.105 28.5823 144.004 24.4968 146.111C21.8987 147.45 18.6015 153.172 16.8612 159.483C16.1671 161.997 16.2018 163.058 17.3719 165.175C18.542 167.292 19.4891 168.239 19.4891 168.239C19.4891 168.239 30.6747 166.231 35.8014 164.917C42.3562 163.242 60.9295 155.447 62.8979 155.666C64.8712 155.884 66.8942 158.085 71.8275 158.164C75.2784 158.219 82.2645 160.574 84.2379 160.207C86.2112 159.84 90.3711 158.75 90.3711 158.75C90.3711 158.75 92.4139 159.92 94.9723 159.335C97.5258 158.75 98.1108 155.829 98.1108 155.829C98.1108 155.829 101.542 160.648 103.292 160.867C105.042 161.085 106.431 159.553 106.064 158.021C105.692 156.489 101.75 150.212 101.75 150.212Z",
    fill: "white",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M101.752 150.211C101.752 149.844 97.5924 145.174 96.4222 144.519C95.2521 143.86 86.0547 142.913 86.0547 142.913",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M98.105 155.834C98.105 155.834 95.4028 152.477 91.8279 150.653C88.2531 148.828 83.3594 147.732 83.3594 147.732",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M90.3637 158.755C90.3637 158.755 83.8685 154.813 81.8952 154.01C79.9218 153.206 78.3203 152.329 78.3203 152.329",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M74.0195 117.561C74.0195 117.561 74.9814 112.37 75.3186 107.158C75.6557 101.947 75.3186 97.3264 75.3186 97.3264",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M116.086 121.33C116.086 121.33 124.158 125.921 126.126 126.68C128.095 127.439 128.853 127.285 129.761 126.427C130.668 125.569 135.616 124.107 136.573 123.854C137.53 123.601 139.652 123.348 140.406 124.057C141.165 124.761 142.122 126.68 142.122 126.68C142.122 126.68 143.381 126.378 144.14 128.093C144.898 129.809 145.503 132.481 145.553 133.393C145.602 134.306 144.645 136.676 144.645 136.676C144.645 136.676 144.442 139.199 143.584 140.662C142.726 142.125 140.961 143.235 140.203 143.335C139.444 143.434 131.724 143.032 131.323 142.477C130.921 141.922 130.767 140.608 130.767 140.608C130.767 140.608 129.002 140.256 128.546 139.799C128.09 139.343 127.083 138.892 127.083 138.892L100.19 135.967C100.19 135.967 97.2154 129.457 101.554 124.409C105.892 119.362 116.086 121.33 116.086 121.33Z",
    fill: "white",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M134.809 142.021C134.809 142.021 137.129 141.971 139.499 140.508C141.869 139.046 144.646 136.676 144.646 136.676",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M153.769 134.112C153.769 134.112 154.801 134.39 155.698 134.524C156.596 134.662 156.868 134.801 157.488 134.246C158.108 133.696 159.833 131.281 160.106 130.522C160.384 129.764 159.764 126.799 158.936 126.665C158.108 126.526 156.938 126.045 156.938 126.045C156.938 126.045 155.49 124.667 154.592 124.597C153.695 124.528 152.664 124.597 152.664 124.597C152.664 124.597 151.355 123.011 150.046 123.011C148.737 123.011 147.77 123.422 147.77 123.422C147.77 123.422 146.6 122.183 145.152 122.594C143.704 123.006 141.637 125.143 141.637 125.143",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M155.146 128.737C155.146 128.737 153.426 135.352 152.598 135.491C151.77 135.629 149.43 134.662 149.43 134.662",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M151.081 126.601C151.081 126.601 150.049 127.91 149.98 129.219C149.911 130.528 149.221 135.144 148.393 135.352C147.565 135.56 145.637 135.144 145.637 135.144",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M146.6 125.014C146.6 125.014 144.944 127.632 145.014 129.63",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M159.515 127.18C159.515 127.18 164.289 125.514 166.545 125.787C168.801 126.06 171.642 126.268 172.718 126.268C173.789 126.268 175.991 127.557 177.493 127.612C178.995 127.666 178.995 127.666 178.995 127.666C178.995 127.666 180.443 129.332 182.213 129.382C183.983 129.436 185.431 128.256 185.431 128.256C185.431 128.256 187.846 128.311 188.922 127.503C189.992 126.699 189.779 124.979 189.779 124.979C189.779 124.979 191.817 124.28 192.303 123.477C192.789 122.673 192.571 121.007 192.571 121.007C192.571 121.007 193.374 117.735 192.948 116.981C192.521 116.228 186.294 112.311 184.524 112.261C182.754 112.207 175.882 113.977 172.074 114.463C168.266 114.944 161.448 115.697 155.439 116.5C149.43 117.304 133.33 117.79 129.146 117.735C124.961 117.681 122.383 116.823 122.383 116.823",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M186.783 116.124C186.683 115.881 192.222 119.897 192.47 120.68",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M184.848 119.793C184.784 119.535 189.747 124.245 189.886 125.059",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M182.669 123.67C182.605 123.413 185.684 127.23 185.827 128.043",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M126.562 117.155C126.562 117.155 128.744 113.669 130.484 108.439C132.23 103.208 133.623 96.8463 133.623 96.8463",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M99.457 67.6124C99.457 67.6124 100.538 72.7144 104.559 78.6642C108.58 84.614 109.661 86.1609 109.815 88.0153C109.968 89.8696 109.582 90.7968 110.048 91.491C110.514 92.1851 111.054 96.7466 111.054 98.7547C111.054 100.763 110.9 103.391 110.9 103.391",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M99.9219 89.0971C99.9219 89.0971 104.87 95.5874 105.797 97.4417C106.724 99.2961 108.966 101.845 113.14 105.325C117.315 108.806 117.543 109.728 118.55 110.888C119.556 112.049 121.411 113.209 122.025 114.136C122.64 115.063 123.419 115.757 123.419 115.757C123.419 115.757 121.257 117.458 120.404 118.464C119.551 119.471 117.39 122.173 117.39 122.173",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M117.305 80.8222C117.305 80.8222 111.746 97.0205 111.469 100.576",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M100.226 66.388C100.226 66.388 96.7602 69.9728 96.3388 71.366C95.9173 72.7593 95.2232 74.7128 95.1538 75.2681C95.0844 75.8234 97.5238 78.5455 100.246 81.8228C102.968 85.1002 104.639 88.9328 104.986 89.7014C105.333 90.4699 105.963 88.3081 107.078 87.7478C108.194 87.1925 109.815 88.0156 109.815 88.0156",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M97.9432 68.3272C97.9432 68.3272 92.1571 68.9965 90.6895 70.9451C89.2218 72.8937 87.7592 73.7316 86.0883 74.5001C84.4174 75.2686 78.418 81.5407 78.418 84.0545",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M122.762 73.3847C122.762 73.3847 128.27 75.477 131.201 76.662C134.131 77.847 137.056 81.2632 139.357 85.2397C141.657 89.2161 143.75 92.7711 145.143 94.9329C146.536 97.0947 147.096 98.2102 148.143 100.441C149.189 102.673 150.721 103.511 152.119 104.274C153.512 105.043 154.211 106.575 155.674 109.436C157.137 112.296 160.484 115.851 160.484 115.851",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M130.082 109.713C130.082 109.713 130.989 111.735 133.359 113.615C135.729 115.494 137.822 117.73 137.822 117.73",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M120.306 76.384C120.306 76.384 122.25 85.1302 121.303 86.3896C120.356 87.649 117.758 88.2043 116.89 90.961C116.022 93.7178 111.074 103.069 111.074 103.069",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M97.4968 56.3634C97.4968 56.3634 99.5197 59.3978 101.186 59.2193C102.852 59.0409 103.923 55.7684 104.339 53.81C104.756 51.8465 104.339 48.1031 111.414 48.9311C118.49 49.7641 122.005 49.9426 124.39 48.3709C127.206 46.5115 126.586 42.9119 125.867 40.6064C125.193 38.4347 121.405 33.5905 121.227 33.7095C121.048 33.8285 119.144 36.6844 116.348 37.2199C113.551 37.7554 101.954 37.9339 99.1627 41.4443C96.3663 44.9547 96.8423 48.4601 97.0208 50.721C97.1993 52.982 97.4968 56.3634 97.4968 56.3634Z",
    fill: "#272637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M108.211 57.5729C108.211 57.5729 113.739 57.6224 118.777 57.0324C123.814 56.4424 128.316 55.0293 128.316 55.0293C128.316 55.0293 128.167 60.4585 126.506 61.6336C124.845 62.8087 122.594 62.6104 121.275 61.9757C119.957 61.3411 118.93 57.915 117.948 57.915C116.967 57.915 117.849 60.1164 115.648 62.1691C113.446 64.2218 111.012 64.435 109.485 63.1954C107.135 61.2865 108.211 57.5729 108.211 57.5729Z",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M108.212 57.573L99.4609 55.7137",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M112.615 60.7507C113.048 60.7507 113.399 60.3999 113.399 59.9673C113.399 59.5346 113.048 59.1839 112.615 59.1839C112.183 59.1839 111.832 59.5346 111.832 59.9673C111.832 60.3999 112.183 60.7507 112.615 60.7507Z",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M123.373 59.482C123.806 59.482 124.157 59.1313 124.157 58.6986C124.157 58.266 123.806 57.9152 123.373 57.9152C122.941 57.9152 122.59 58.266 122.59 58.6986C122.59 59.1313 122.941 59.482 123.373 59.482Z",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M109.336 56.2043L113.888 55.763",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M119.805 55.6138C119.805 55.6138 121.272 54.1462 123.375 54.7809",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M118.825 61.0926C118.825 61.0926 118.974 63.0957 119.509 64.2708C120.045 65.4459 120.437 66.2293 120.437 66.2293C120.437 66.2293 119.554 66.8639 117.992 66.7697",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M113.449 70.0923C113.449 70.0923 114.674 70.3352 116.528 70.1419C118.388 69.9485 119.756 69.0659 119.756 69.0659C119.756 69.0659 120.247 71.5599 118.045 72.145C115.844 72.735 113.449 70.0923 113.449 70.0923Z",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M124.544 46.1438C124.544 46.1438 125.659 61.6282 125.069 65.8922C124.479 70.1562 121.985 76.6514 117.394 77.5737C112.803 78.4909 109.129 76.1953 106.699 73.1113",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M98.5648 56.4474C98.5648 56.4474 96.5319 55.8573 96.2691 57.563C96.0064 59.2686 97.1219 63.9293 98.4359 64.4548C99.7498 64.9804 100.404 64.4548 100.404 64.4548L100.93 71.7384",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M118.049 77.6379L116.934 86.6965",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M59.8961 88.6355C59.8961 88.6355 59.1921 83.8707 59.0532 81.218C58.9144 78.5654 58.969 78.858 58.969 78.858L46.0083 56.3925L48.3783 52.9069L41.0005 51.3996L33.0625 58.4154C33.0625 58.4154 39.2453 68.1433 45.9488 75.1542C52.6522 82.1651 59.8961 88.6355 59.8961 88.6355Z",
    fill: "#C1C1C8",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M65.2383 66.8842L66.3737 71.7928",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M52.9691 44.8705L48.3828 52.9077",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M59.8937 88.6359L59.0508 79.4831L67.1277 62.7592L68.5953 73.3499L59.8937 88.6359Z",
    fill: "#C1C1C8",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M61.6497 27.9029C61.6497 27.9029 59.4492 30.5783 61.4661 34.087C63.3125 37.2958 65.6128 38.2631 68.7529 37.8284C72.803 37.2726 74.3754 35.3128 75.197 32.5926C75.9662 30.0475 73.5544 26.2887 73.5544 26.2887C73.5544 26.2887 73.5153 27.4272 72.7636 27.6322C71.3663 28.0257 71.702 25.4471 71.5068 24.1567C71.2581 22.5262 69.5586 21.363 68.1201 20.3838C66.6817 19.4047 65.5067 18.9939 65.5067 18.9939C65.5067 18.9939 66.789 22.2622 66.3533 23.325C65.8706 24.5041 64.8204 23.3623 64.8204 23.3623C64.8204 23.3623 63.7353 25.2819 63.8633 26.699C63.9913 28.1161 64.3986 29.5547 63.2765 29.8978C62.1545 30.2408 61.6497 27.9029 61.6497 27.9029Z",
    fill: "#30D5C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M68.4525 37.6148C68.102 37.648 67.7539 37.5575 67.4622 37.3637C66.9667 37.0277 66.1759 36.3824 65.555 35.3403C64.5862 33.6995 65.1211 31.7428 65.1211 31.7428C65.1211 31.7428 65.66 32.3551 65.9008 31.5769C66.1416 30.7988 65.7894 28.2772 66.4624 26.9231C67.1366 25.5761 68.0729 24.9284 68.0729 24.9284C68.0729 24.9284 67.6713 28.2432 69.0982 29.9355C70.5323 31.6267 71.0344 31.2648 71.4532 33.1008C71.8969 35.0491 70.0043 36.9575 69.5365 37.3067C69.2835 37.4989 68.8171 37.5793 68.4525 37.6148Z",
    fill: "#C1C1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M67.8665 30.6068C67.8665 30.6068 68.5767 31.4317 69.4538 32.6731C70.3309 33.9146 70.2454 36.0983 68.9103 36.6563C67.5752 37.2142 66.6862 35.1108 66.7077 34.4615C66.728 33.805 66.8158 33.2541 66.8158 33.2541L67.3534 33.9972C67.3534 33.9972 67.4852 34.1435 67.4126 32.8483C67.3389 31.5461 67.8665 30.6068 67.8665 30.6068Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M77.9486 28.2268C77.9486 28.2268 75.0571 30.1343 75.9498 34.0818C76.7679 37.6924 78.6808 39.2949 81.8094 39.8054C85.8434 40.4685 87.9237 39.0595 89.5108 36.7025C90.9962 34.4974 89.8 30.1945 89.8 30.1945C89.8 30.1945 89.427 31.2708 88.6482 31.2451C87.1971 31.2091 88.2782 28.8441 88.4721 27.5535C88.7153 25.9222 87.4342 24.3096 86.3484 22.9498C85.2627 21.5901 84.261 20.8511 84.261 20.8511C84.261 20.8511 84.5226 24.3522 83.793 25.2393C82.984 26.2236 82.3172 24.8229 82.3172 24.8229C82.3172 24.8229 80.7143 26.3372 80.4188 27.7291C80.1233 29.1209 80.0882 30.6157 78.9149 30.6126C77.7416 30.6095 77.9486 28.2268 77.9486 28.2268Z",
    fill: "#30D5C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M81.5817 39.5128C81.237 39.4412 80.9311 39.252 80.7095 38.9809C80.3351 38.5137 79.7697 37.664 79.4837 36.4851C79.0418 34.6315 80.1298 32.9196 80.1298 32.9196C80.1298 32.9196 80.4642 33.6635 80.9237 32.991C81.3762 32.3174 81.7903 29.8052 82.8326 28.7097C83.874 27.6214 84.9597 27.2785 84.9597 27.2785C84.9597 27.2785 83.5985 30.3275 84.463 32.3653C85.3347 34.4042 85.9211 34.2064 85.78 36.0843C85.6294 38.0767 83.2583 39.3423 82.7083 39.5381C82.41 39.6471 81.9406 39.5864 81.5817 39.5128Z",
    fill: "#C1C1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M83.0923 32.6441C83.0923 32.6441 83.5277 33.6417 83.9998 35.0866C84.4718 36.5315 83.7462 38.5929 82.306 38.7324C80.8647 38.879 80.6364 36.5999 80.8484 35.9857C81.0614 35.3644 81.3077 34.8639 81.3077 34.8639L81.6023 35.7325C81.6023 35.7325 81.6852 35.9111 81.9977 34.6522C82.3183 33.3871 83.0923 32.6441 83.0923 32.6441Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M24.9961 139.076L29.1263 114.498",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M53.7403 43.8934L52.1289 47.4633L57.9647 53.7998L60.419 50.9935L53.7403 43.8934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M131.731 147.474L131.305 144.222L136.536 116.446C136.536 116.446 137.155 115.866 138.201 116.059C139.248 116.253 139.287 116.6 139.287 116.6L134.175 144.727L131.731 147.474Z",
    fill: "#30D5C8",
    stroke: "#272637",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.455 128.892L130.921 130.518C130.921 130.518 134 132.536 134 133.949C134 135.362 133.395 136.473 132.285 136.676C131.174 136.88 129.31 136.121 127.793 135.06C126.28 133.999 125.066 132.888 124.867 132.333",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.455 128.892L130.921 130.518C130.921 130.518 134 132.536 134 133.949C134 135.362 133.395 136.473 132.285 136.676C131.174 136.88 129.31 136.121 127.793 135.06C126.28 133.999 125.066 132.888 124.867 132.333",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.209 128.687L137.884 130.462C137.884 130.462 134.353 134.146 133.848 136.065C133.342 137.984 133.848 139.04 134.453 139.446C135.057 139.853 135.915 140.151 136.267 139.798C136.619 139.446 142.777 133.14 143.283 132.381C143.789 131.622 144.394 128.95 144.394 128.95",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.209 128.687L137.884 130.462C137.884 130.462 134.353 134.146 133.848 136.065C133.342 137.984 133.848 139.04 134.453 139.446C135.057 139.853 135.915 140.151 136.267 139.798C136.619 139.446 142.777 133.14 143.283 132.381C143.789 131.622 144.394 128.95 144.394 128.95",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M105.616 116.104C105.616 116.104 98.6601 116.516 94.5547 121.647",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M216.953 70.6574C216.953 70.6574 249.999 156.811 249.999 159.696C249.999 162.582 213.259 168.839 208.767 167.396C204.275 165.953 182.137 156.652 182.137 153.439C182.137 151.996 208.951 153.117 227.697 153.117C233.31 153.117 237.485 153.117 237.643 152.636C237.802 152.155 218.069 97.7687 218.069 97.7687L216.953 70.6574Z",
    fill: "#C1C1C8",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M189.004 35.0081L190.02 129.516L215.694 156.092L218.698 155.492L217.499 1.74868L214.796 1L189.004 35.0081Z",
    fill: "#C1C1C8",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M215.694 156.092L214.797 1",
    stroke: "#272637",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M213.861 131.192L191.901 116L190.656 36.9967L212.76 8.68053L213.861 131.192Z",
    fill: "#272637"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.ddf0c48dabd4a3454ad15e22ce895d2e.svg";
export { ForwardRef as ReactComponent };